import React from 'react';
import { Container, Row, Col, Fade } from 'reactstrap';
import { LoadingCard } from '../../components/Cards';

const LoadingView = () => (
  <Fade>
    <Container fluid className="mt-3">
      <Row>
        <Col>
          <LoadingCard items={[]} />
        </Col>
      </Row>
    </Container>
  </Fade>
);
export default LoadingView;
